<div class="container">
  <ngx-skeleton-loader [count]="count"
                       [appearance]="appearance"
                       [animation]="animation"
                       [theme]="mergedTheme"
  ></ngx-skeleton-loader>
</div>
